import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { Button } from '@abroad/components'

export const SCHEDULING_REQUIREMENT_VARIANT = {
  AVAILABILITY: 'availability',
  VIDEO_CALL_LINK: 'videoCallLink',
}

const MODAL_CONTENT = {
  [SCHEDULING_REQUIREMENT_VARIANT.AVAILABILITY]: {
    title: 'Availability Required',
    message: 'For this, you need to set time availability.',
    actionLabel: 'Go to Availability',
  },
  [SCHEDULING_REQUIREMENT_VARIANT.VIDEO_CALL_LINK]: {
    title: 'Video Call Link Required',
    message: 'For this, you need to set a video call link.',
    actionLabel: 'Go to Video Call Link',
  },
}

const AvailabilityRequiredModal = ({
  show = false,
  variant = SCHEDULING_REQUIREMENT_VARIANT.AVAILABILITY,
  handleClose = () => {},
  onConfirm = () => {},
}) => {
  const content =
    MODAL_CONTENT[variant] ||
    MODAL_CONTENT[SCHEDULING_REQUIREMENT_VARIANT.AVAILABILITY]

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size='lg'
      className='payment-modal'
      dialogClassName='payment-modal-dialog justify-content-center'>
      <Modal.Header className='payment-modal-header d-flex justify-content-center'>
        <h3 className='payment-modal-title mb-0 text-uppercase'>
          {content.title}
        </h3>
      </Modal.Header>
      <Modal.Body className='payment-modal-body'>
        <div className='sa4 font-15px text-center'>{content.message}</div>
      </Modal.Body>
      <Modal.Footer className='border-0 d-flex justify-content-end gap-3 flex-row'>
        <Button
          variant='secondary-light'
          className='px-4 text-uppercase secondary-popup-button'
          size='sm'
          onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant='saffron'
          className='px-4 text-uppercase'
          size='sm'
          onClick={onConfirm}>
          {content.actionLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

AvailabilityRequiredModal.propTypes = {
  show: PropTypes.bool,
  variant: PropTypes.oneOf(Object.values(SCHEDULING_REQUIREMENT_VARIANT)),
  handleClose: PropTypes.func,
  onConfirm: PropTypes.func,
}

export default AvailabilityRequiredModal
